import { StateCreator } from "zustand";
import { WorkspaceState } from "../WorkspaceStore";

export interface WorkspaceConfigurationSlice {
  activeConfigTab: number;
  expandedAdvancedConfig: string | false;
  setActiveConfigTab: (tab: number) => void;
  setAdvancedConfigExpanded: (panel: string | false) => void;
}

type WorkspaceStateWithConfigurationSlice = WorkspaceState &
  WorkspaceConfigurationSlice;

export const createWorkspaceConfigurationSlice: StateCreator<
  WorkspaceStateWithConfigurationSlice,
  [],
  [],
  WorkspaceConfigurationSlice
> = (set) => ({
  activeConfigTab: 0,
  expandedAdvancedConfig: false,
  setActiveConfigTab: (tab) => set({ activeConfigTab: tab }),
  setAdvancedConfigExpanded: (panel) => set({ expandedAdvancedConfig: panel }),
});
